import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  Typography,
  Button,
  IconButton,
  Grid,
  MenuItem,
  TextField,
  Switch,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import _ from "lodash";
import { useFormik } from "formik";
import * as yup from "yup";
import dayjs from "dayjs";
import { CUSTOM_CONSTANTS } from "Constants";

// Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

// Services
import servicefaretypeapi from "Services/Servicefare";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ServiceUpdate = (props) => {
  const { openDialog, id, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const [details, setDetails] = useState([]);

  // Fetch servicefare Details
  const getDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setDetails(res?.data?.data);
      } else {
        setDetails(null);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    servicefaretypeapi.getServicefarebyid(id).then(onSuccess, onFailure);
  }, [id, dispatch]);

  useEffect(() => {
    openDialog && id && getDetails();
  }, [openDialog, id, getDetails]);

  const formatTime = (time) => {
    if (time && dayjs.isDayjs(time)) {
      return time.format("hh:mm:ss A");
    }
    return null;
  };

  const handleUpdateServicetype = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const payload = {
      ...formValues,
      Daystartingtime: formValues.daystartingtime ? formatTime(formValues.daystartingtime) : null,
      Nightstartingtime: formValues.nightstartingtime ? formatTime(formValues.nightstartingtime) : null,
      Dayendingtime: formValues.dayendingtime ? formatTime(formValues.dayendingtime) : null,
      Nightendingtime: formValues.nightendingtime ? formatTime(formValues.nightendingtime) : null,
      DaystartingtimeWeekend: formValues.daystartingtimeWeekend ? formatTime(formValues.daystartingtimeWeekend) : null,
      NightstartingtimeWeekend: formValues.nightstartingtimeWeekend ? formatTime(formValues.nightstartingtimeWeekend) : null,
      DayendingtimeWeekend: formValues.dayendingtimeWeekend ? formatTime(formValues.dayendingtimeWeekend) : null,
      NightendingtimeWeekend: formValues.nightendingtimeWeekend ? formatTime(formValues.nightendingtimeWeekend) : null,
      SurgeHouronestartingTime: formValues.surgeHouronestartingTime ? formatTime(formValues.surgeHouronestartingTime) : null,
      SurgerHourtwostartingTime: formValues.surgerHourtwostartingTime ? formatTime(formValues.surgerHourtwostartingTime) : null,
      SurgeHouroneendingTime: formValues.surgeHouroneendingTime ? formatTime(formValues.surgeHouroneendingTime) : null,
      SurgerHourtwoendingTime: formValues.surgerHourtwoendingTime ? formatTime(formValues.surgerHourtwoendingTime) : null,
      dayRange: "MONDAY-SUNDAY",
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Service fare Details Updated Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to update data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    servicefaretypeapi.updateServicefare(id, payload).then(onSuccess, onFailure);
  };

  const timeToString = (time) => {
    if (!time || typeof time !== "object") return "";
    const hour = time.hour.toString().padStart(2, "0");
    const minutes = time.minutes.toString().padStart(2, "0");
    return `${hour}:${minutes} ${time.Median}`;
  };

  const timeToDayjs = (time) => {
    if (!time) return null;
    const timeString = timeToString(time);
    return dayjs(timeString, "hh:mm A");
  };

  // Populate form values from fetched details
  useEffect(() => {
    if (!_.isEmpty(details) && details[0]) {
      const d = details[0];
      formik.setFieldValue("servicename", d?.serviceTypeId?.serviceName || "");
      formik.setFieldValue("surgeHourone", d?.surgeHourone?.isActive || false);
      formik.setFieldValue("surgeHourtwo", d?.surgeHourtwo?.isActive || false);
      formik.setFieldValue("isActive", d?.isActive ?? true);
      formik.setFieldValue("Premiumfare", d?.Premiumfare ?? false);
      formik.setFieldValue("deliveryType", d?.deliveryType ?? false);
        formik.setFieldValue("TruckType", d?.TruckType ?? false);
      formik.setFieldValue("cargohelper", d?.cargohelper ?? "");
      formik.setFieldValue("priceperperson", d?.priceperperson ?? "");



      formik.setFieldValue("daystartingtime", timeToDayjs(d?.daytime?.startingTime));
      formik.setFieldValue("nightstartingtime", timeToDayjs(d?.nighttime?.startingTime));
      formik.setFieldValue("dayendingtime", timeToDayjs(d?.daytime?.endingTime));
      formik.setFieldValue("nightendingtime", timeToDayjs(d?.nighttime?.endingTime));
      formik.setFieldValue("daybaseprice", d?.daytime?.basePrice || "");
      formik.setFieldValue("nightbaseprice", d?.nighttime?.basePrice || "");
      formik.setFieldValue("daydistanceprice", d?.daytime?.unitPrice || "");
      formik.setFieldValue("nightdistanceprice", d?.nighttime?.unitPrice || "");
      formik.setFieldValue("dayminuteprice", d?.daytime?.minutePrice || "");
      formik.setFieldValue("nightminuteprice", d?.nighttime?.minutePrice || "");
      formik.setFieldValue("FreeTripWaitingMinuteday", d?.daytime?.FreeTripWaitingMinute || "");
      formik.setFieldValue("FreeTripWaitingMinutenight", d?.nighttime?.FreeTripWaitingMinute || "");
      formik.setFieldValue("WaitingPriceperminday", d?.daytime?.WaitingPricepermin || "");
      formik.setFieldValue("WaitingPriceperminnight", d?.nighttime?.WaitingPricepermin || "");
      formik.setFieldValue("FreeStopsWaitingperminday", d?.daytime?.FreeStopsWaitingpermin || "");
      formik.setFieldValue("FreeStopsWaitingperminnight", d?.nighttime?.FreeStopsWaitingpermin || "");
      formik.setFieldValue("StopWaitingPriceperminday", d?.daytime?.StopWaitingPricepermin || "");
      formik.setFieldValue("StopWaitingPriceperminnight", d?.nighttime?.StopWaitingPricepermin || "");

      formik.setFieldValue("daystartingtimeWeekend", timeToDayjs(d?.daytimeWeekend?.startingTime));
      formik.setFieldValue("nightstartingtimeWeekend", timeToDayjs(d?.nighttimeWeekend?.startingTime));
      formik.setFieldValue("dayendingtimeWeekend", timeToDayjs(d?.daytimeWeekend?.endingTime));
      formik.setFieldValue("nightendingtimeWeekend", timeToDayjs(d?.nighttimeWeekend?.endingTime));
      formik.setFieldValue("daybasepriceWeekend", d?.daytimeWeekend?.basePrice || "");
      formik.setFieldValue("nightbasepriceWeekend", d?.nighttimeWeekend?.basePrice || "");
      formik.setFieldValue("daydistancepriceWeekend", d?.daytimeWeekend?.unitPrice || "");
      formik.setFieldValue("nightdistancepriceWeekend", d?.nighttimeWeekend?.unitPrice || "");
      formik.setFieldValue("dayminutepriceWeekend", d?.daytimeWeekend?.minutePrice || "");
      formik.setFieldValue("nightminutepriceWeekend", d?.nighttimeWeekend?.minutePrice || "");
      formik.setFieldValue("FreeTripWaitingMinutedayWeekend", d?.daytimeWeekend?.FreeTripWaitingMinute || "");
      formik.setFieldValue("FreeTripWaitingMinutenightWeekend", d?.nighttimeWeekend?.FreeTripWaitingMinute || "");
      formik.setFieldValue("WaitingPricepermindayWeekend", d?.daytimeWeekend?.WaitingPricepermin || "");
      formik.setFieldValue("WaitingPriceperminnightWeekend", d?.nighttimeWeekend?.WaitingPricepermin || "");
      formik.setFieldValue("FreeStopsWaitingpermindayWeekend", d?.daytimeWeekend?.FreeStopsWaitingpermin || "");
      formik.setFieldValue("FreeStopsWaitingperminnightWeekend", d?.nighttimeWeekend?.FreeStopsWaitingpermin || "");
      formik.setFieldValue("StopWaitingPricepermindayWeekend", d?.daytimeWeekend?.StopWaitingPricepermin || "");
      formik.setFieldValue("StopWaitingPriceperminnightWeekend", d?.nighttimeWeekend?.StopWaitingPricepermin || "");

      formik.setFieldValue("surgeHouronestartingTime", timeToDayjs(d?.surgeHourone?.startingTime));
      formik.setFieldValue("surgerHourtwostartingTime", timeToDayjs(d?.surgeHourtwo?.startingTime));
      formik.setFieldValue("surgeHouroneendingTime", timeToDayjs(d?.surgeHourone?.endingTime));
      formik.setFieldValue("surgerHourtwoendingTime", timeToDayjs(d?.surgeHourtwo?.endingTime));
      formik.setFieldValue("surgeHouronepercentage", d?.surgeHourone?.percentage || "");
      formik.setFieldValue("surgerHourtwopercentage", d?.surgeHourtwo?.percentage || "");
    }
  }, [details]);

  const formik = useFormik({
    initialValues: {
      servicename: "",
      surgeHourone: false,
      surgeHourtwo: false,
      isActive: true,
      Premiumfare: false,
      deliveryType: false,
TruckType: false,
      cargohelper: "",
      priceperperson: "",
      daystartingtime: null,
      nightstartingtime: null,
      dayendingtime: null,
      nightendingtime: null,
      daystartingtimeWeekend: null,
      nightstartingtimeWeekend: null,
      dayendingtimeWeekend: null,
      nightendingtimeWeekend: null,
      daybaseprice: "",
      nightbaseprice: "",
      daybasepriceWeekend: "",
      nightbasepriceWeekend: "",
      daydistanceprice: "",
      nightdistanceprice: "",
      daydistancepriceWeekend: "",
      nightdistancepriceWeekend: "",
      dayminuteprice: "",
      nightminuteprice: "",
      dayminutepriceWeekend: "",
      nightminutepriceWeekend: "",
      surgeHouronestartingTime: null,
      surgerHourtwostartingTime: null,
      surgeHouroneendingTime: null,
      surgerHourtwoendingTime: null,
      surgeHouronepercentage: "",
      surgerHourtwopercentage: "",
      FreeTripWaitingMinuteday: "",
      FreeTripWaitingMinutenight: "",
      WaitingPriceperminday: "",
      WaitingPriceperminnight: "",
      FreeStopsWaitingperminday: "",
      FreeStopsWaitingperminnight: "",
      StopWaitingPriceperminday: "",
      StopWaitingPriceperminnight: "",
      FreeTripWaitingMinutedayWeekend: "",
      FreeTripWaitingMinutenightWeekend: "",
      WaitingPricepermindayWeekend: "",
      WaitingPriceperminnightWeekend: "",
      FreeStopsWaitingpermindayWeekend: "",
      FreeStopsWaitingperminnightWeekend: "",
      StopWaitingPricepermindayWeekend: "",
      StopWaitingPriceperminnightWeekend: "",
    },
    validationSchema: yup.object({
      servicename: yup.string().required("Service Type is required").nullable(),
      daystartingtime: yup.string().required("Day starting time is required").nullable(),
      nightstartingtime: yup.string().required("Night starting time is required").nullable(),
      dayendingtime: yup.string().required("Day ending time is required").nullable(),
      nightendingtime: yup.string().required("Night ending time is required").nullable(),
      daystartingtimeWeekend: yup.string().required("Day starting time is required").nullable(),
      nightstartingtimeWeekend: yup.string().required("Night starting time is required").nullable(),
      dayendingtimeWeekend: yup.string().required("Day ending time is required").nullable(),
      nightendingtimeWeekend: yup.string().required("Night ending time is required").nullable(),
      daybaseprice: yup.number().typeError("Must be a number").required("Required"),
      nightbaseprice: yup.number().typeError("Must be a number").required("Required"),
      daydistanceprice: yup.number().typeError("Must be a number").required("Required"),
      nightdistanceprice: yup.number().typeError("Must be a number").required("Required"),
      dayminuteprice: yup.number().typeError("Must be a number").required("Required"),
      nightminuteprice: yup.number().typeError("Must be a number").required("Required"),
      FreeTripWaitingMinuteday: yup.number().typeError("Must be a number").required("Required"),
      FreeTripWaitingMinutenight: yup.number().typeError("Must be a number").required("Required"),
      WaitingPriceperminday: yup.number().typeError("Must be a number").required("Required"),
      WaitingPriceperminnight: yup.number().typeError("Must be a number").required("Required"),
      FreeStopsWaitingperminday: yup.number().typeError("Must be a number").required("Required"),
      FreeStopsWaitingperminnight: yup.number().typeError("Must be a number").required("Required"),
      StopWaitingPriceperminday: yup.number().typeError("Must be a number").required("Required"),
      StopWaitingPriceperminnight: yup.number().typeError("Must be a number").required("Required"),
      daybasepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      nightbasepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      daydistancepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      nightdistancepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      dayminutepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      nightminutepriceWeekend: yup.number().typeError("Must be a number").required("Required"),
      FreeTripWaitingMinutedayWeekend: yup.number().typeError("Must be a number").required("Required"),
      FreeTripWaitingMinutenightWeekend: yup.number().typeError("Must be a number").required("Required"),
      WaitingPricepermindayWeekend: yup.number().typeError("Must be a number").required("Required"),
      WaitingPriceperminnightWeekend: yup.number().typeError("Must be a number").required("Required"),
      FreeStopsWaitingpermindayWeekend: yup.number().typeError("Must be a number").required("Required"),
      FreeStopsWaitingperminnightWeekend: yup.number().typeError("Must be a number").required("Required"),
      StopWaitingPricepermindayWeekend: yup.number().typeError("Must be a number").required("Required"),
      StopWaitingPriceperminnightWeekend: yup.number().typeError("Must be a number").required("Required"),
       cargohelper: yup.number().typeError("Must be a number").nullable(),
      priceperperson: yup.number().typeError("Must be a number").nullable(),

   }),
    enableReinitialize: true,
    onSubmit: handleUpdateServicetype,
  });

  const renderTimePicker = (name, value) => (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker
        ampm={true}
        value={value}
        onChange={(newValue) => formik.setFieldValue(name, newValue)}
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            variant: "outlined",
            className: classes.inputShape,
            error: Boolean(formik?.errors?.[name] && formik?.touched?.[name]),
            helperText: formik?.touched?.[name] && formik?.errors?.[name],
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            fullWidth
            variant="outlined"
            className={classes.inputShape}
            error={Boolean(formik?.errors?.[name] && formik?.touched?.[name])}
            helperText={formik?.touched?.[name] && formik?.errors?.[name]}
          />
        )}
      />
    </LocalizationProvider>
  );

  const renderTextField = (name, placeholder = "0.00") => (
    <TextField
      name={name}
      id={name}
      placeholder={placeholder}
      value={formik?.values?.[name]}
      onChange={formik.handleChange}
      error={Boolean(formik?.errors?.[name] && formik?.touched?.[name])}
      helperText={formik?.touched?.[name] && formik?.errors?.[name]}
      fullWidth
      variant="outlined"
      size="small"
      className={classes.inputShape}
    />
  );

  const handleModalClose = () => {
    formik.resetForm();
    handleClose();
  };

  return (
    <Dialog
      open={openDialog}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleModalClose}
      maxWidth="lg"
      className={classes.root}
    >
      {/* Header */}
      <DialogTitle className={classes.dialogTitle}>
        <Typography className={classes.titleText}>Update Fare model</Typography>
        <IconButton aria-label="close" onClick={handleModalClose} className={classes.closeButton}>
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.dialogContent}>
        {/* Top Controls Row */}
        <Box className={classes.topControlsRow}>
          <Box className={classes.topControlsLeft}>
            {/* Service Type */}
            <Box className={classes.serviceTypeSelect}>
              <Typography className={classes.fieldLabel}>Service Type</Typography>
              <TextField
                disabled
                name="servicename"
                id="servicename"
                value={formik?.values?.servicename}
                onChange={formik.handleChange}
                error={Boolean(formik?.errors?.servicename && formik?.touched?.servicename)}
                helperText={formik?.touched?.servicename && formik?.errors?.servicename}
                fullWidth
                variant="outlined"
                size="small"
                className={classes.inputShape}
              />
            </Box>

            {/* Surge Hour (One) Switch */}
            <Box className={classes.switchPillBox}>
              <Switch
                checked={formik.values.surgeHourone === true}
                onChange={(e) => formik.setFieldValue("surgeHourone", e.target.checked)}
                className={classes.redSwitch}
              />
              <Typography className={classes.switchPillLabel}>Surge Hour (One)</Typography>
            </Box>

            {/* Surge Hour (Two) Switch */}
            <Box className={classes.switchPillBox}>
              <Switch
                checked={formik.values.surgeHourtwo === true}
                onChange={(e) => formik.setFieldValue("surgeHourtwo", e.target.checked)}
                className={classes.redSwitch}
                sx={{
                  '& .MuiSwitch-switchBase': {
                    // Styles when UNCHECKED (Error state)
                    color: 'error.main',
                    '& + .MuiSwitch-track': {
                      backgroundColor: 'error.main',
                      opacity: 0.3,
                    },
                    // Styles when CHECKED (Success state)
                    '&.Mui-checked': {
                      color: 'success.main',
                      '& + .MuiSwitch-track': {
                        backgroundColor: 'success.main',
                        opacity: 0.5,
                      },
                    },
                  },
                }}
              />
              <Typography className={classes.switchPillLabel}>Surge Hour (Two)</Typography>
            </Box>
            

            {/* Fare Type Select */}
            <Box className={classes.switchPillBox}>
              <Typography className={classes.fieldLabel} style={{ marginRight: 8 }}>Fare Type</Typography>
              <TextField
                select
                size="small"
                variant="outlined"
                className={classes.inputShape}
                style={{ minWidth: 160 }}
                value={
                  formik.values.Premiumfare ? "Premiumfare"
                  : formik.values.deliveryType ? "deliveryType"
                  : formik.values.TruckType ? "TruckType"
                  : ""
                }
                onChange={(e) => {
                  const val = e.target.value;
                  formik.setFieldValue("Premiumfare", val === "Premiumfare");
                  formik.setFieldValue("deliveryType", val === "deliveryType");
                  formik.setFieldValue("TruckType", val === "TruckType");
                  if (val !== "TruckType") {
                    formik.setFieldValue("cargohelper", "");
                    formik.setFieldValue("priceperperson", "");
                  }
                }}
              >
                <MenuItem value="" style={{ fontSize: 12 }}>None</MenuItem>
                <MenuItem value="Premiumfare" style={{ fontSize: 12 }}>Premium Fare</MenuItem>
                <MenuItem value="deliveryType" style={{ fontSize: 12 }}>Delivery Type</MenuItem>
                <MenuItem value="TruckType" style={{ fontSize: 12 }}>Truck Type</MenuItem>
              </TextField>
            </Box>

            {/* If Truck Type is selected: show Cargo Helper Person count and Price Per Person */}
            {formik.values.TruckType && (
              <>
                <Box className={classes.switchPillBox}>
                  <Typography className={classes.fieldLabel} style={{ marginRight: 8 }}>
                    Cargo Helper Person
                  </Typography>
                  <TextField
                    name="cargohelper"
                    id="cargohelper"
                    type="number"
                    placeholder="e.g. 2"
                    size="small"
                    variant="outlined"
                    className={classes.inputShape}
                    style={{ width: 100 }}
                    value={formik.values.cargohelper}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.cargohelper && formik.touched.cargohelper)}
                    helperText={formik.touched.cargohelper && formik.errors.cargohelper}
                  />
                </Box>
                <Box className={classes.switchPillBox}>
                  <Typography className={classes.fieldLabel} style={{ marginRight: 8 }}>
                    Price Per Person
                  </Typography>
                  <TextField
                    name="priceperperson"
                    id="priceperperson"
                    type="number"
                    placeholder="0.00"
                    size="small"
                    variant="outlined"
                    className={classes.inputShape}
                    style={{ width: 100 }}
                    value={formik.values.priceperperson}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.priceperperson && formik.touched.priceperperson)}
                    helperText={formik.touched.priceperperson && formik.errors.priceperperson}
                  />
                </Box>
              </>
            )}


          </Box>

          {/* Active Status Switch */}
          <Box className={classes.switchPillBox}>
            <Typography className={classes.activeStatusLabel}>ACTIVE STATUS</Typography>
            <Switch
              checked={formik.values.isActive === true}
              onChange={(e) => formik.setFieldValue("isActive", e.target.checked)}
              className={classes.greenSwitch}
              sx={{
                '& .MuiSwitch-switchBase': {
                  // Styles when UNCHECKED (Error state)
                  color: 'error.main',
                  '& + .MuiSwitch-track': {
                    backgroundColor: 'error.main',
                    opacity: 0.3,
                  },
                  // Styles when CHECKED (Success state)
                  '&.Mui-checked': {
                    color: 'success.main',
                    '& + .MuiSwitch-track': {
                      backgroundColor: 'success.main',
                      opacity: 0.5,
                    },
                  },
                },
              }}
            />
          </Box>
        </Box>

        {/* Tariff Columns (Side-by-Side) */}
        <Grid container spacing={2.5}>
          {/* MONDAY - THURSDAY TARIFF */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.sectionTitleHeader}>
              <b>MONDAY - THURSDAY TARIFF</b>
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Box className={classes.subHeaderRow}>
              <Typography className={classes.subHeaderText}>DAY TIME SETTINGS</Typography>
              <Typography className={classes.subHeaderText}>NIGHT TIME SETTINGS</Typography>
            </Box>

            <Grid container spacing={1.5}>
              {/* Starting Time */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("daystartingtime", formik.values.daystartingtime)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightstartingtime", formik.values.nightstartingtime)}</Grid>
                </Grid>
              </Grid>

              {/* Ending Time */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("dayendingtime", formik.values.dayendingtime)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightendingtime", formik.values.nightendingtime)}</Grid>
                </Grid>
              </Grid>

              {/* Base Price */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daybaseprice")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightbaseprice")}</Grid>
                </Grid>
              </Grid>

              {/* Distance Price / KM */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Distance Price / KM ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daydistanceprice")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightdistanceprice")}</Grid>
                </Grid>
              </Grid>

              {/* Minute Price / Min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Minute Price / Min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("dayminuteprice")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightminuteprice")}</Grid>
                </Grid>
              </Grid>

              {/* Free Trip Waiting per min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Free Trip Waiting per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("FreeTripWaitingMinuteday")}</Grid>
                  <Grid item xs={6}>{renderTextField("FreeTripWaitingMinutenight")}</Grid>
                </Grid>
              </Grid>

              {/* Waiting Price / Min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Waiting Price / Min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("WaitingPriceperminday")}</Grid>
                  <Grid item xs={6}>{renderTextField("WaitingPriceperminnight")}</Grid>
                </Grid>
              </Grid>

              {/* Free Stop Waiting Price */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Free Stop Waiting Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("FreeStopsWaitingperminday")}</Grid>
                  <Grid item xs={6}>{renderTextField("FreeStopsWaitingperminnight")}</Grid>
                </Grid>
              </Grid>

              {/* Stop Waiting Price per min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Stop Waiting Price per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("StopWaitingPriceperminday")}</Grid>
                  <Grid item xs={6}>{renderTextField("StopWaitingPriceperminnight")}</Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* FRIDAY - SUNDAY TARIFF */}
          <Grid item xs={12} md={6}>
            <Typography className={classes.sectionTitleHeader}>
              <b>FRIDAY - SUNDAY TARIFF</b>
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Box className={classes.subHeaderRow}>
              <Typography className={classes.subHeaderText}>DAY TIME SETTINGS</Typography>
              <Typography className={classes.subHeaderText}>NIGHT TIME SETTINGS</Typography>
            </Box>

            <Grid container spacing={1.5}>
              {/* Starting Time */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("daystartingtimeWeekend", formik.values.daystartingtimeWeekend)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightstartingtimeWeekend", formik.values.nightstartingtimeWeekend)}</Grid>
                </Grid>
              </Grid>

              {/* Ending Time */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTimePicker("dayendingtimeWeekend", formik.values.dayendingtimeWeekend)}</Grid>
                  <Grid item xs={6}>{renderTimePicker("nightendingtimeWeekend", formik.values.nightendingtimeWeekend)}</Grid>
                </Grid>
              </Grid>

              {/* Base Price */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Base Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daybasepriceWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightbasepriceWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Distance Price / KM */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Distance Price / KM ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("daydistancepriceWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightdistancepriceWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Minute Price / Min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Minute Price / Min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("dayminutepriceWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("nightminutepriceWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Free Trip Waiting per min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Free Trip Waiting per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("FreeTripWaitingMinutedayWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("FreeTripWaitingMinutenightWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Waiting Price / Min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Waiting Price / Min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("WaitingPricepermindayWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("WaitingPriceperminnightWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Free Stop Waiting Price */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Free Stop Waiting Price ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("FreeStopsWaitingpermindayWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("FreeStopsWaitingperminnightWeekend")}</Grid>
                </Grid>
              </Grid>

              {/* Stop Waiting Price per min */}
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Stop Waiting Price per min ({CUSTOM_CONSTANTS.BASE_CURRENCY}) :</Typography>
                <Grid container spacing={1.5}>
                  <Grid item xs={6}>{renderTextField("StopWaitingPricepermindayWeekend")}</Grid>
                  <Grid item xs={6}>{renderTextField("StopWaitingPriceperminnightWeekend")}</Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Surge Based Fare Sections */}
          <Grid item xs={12} md={6} style={{ marginTop: 12 }}>
            <Typography className={classes.sectionTitleHeader}>
              Surge based fare Surge Hour (One)
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                {renderTimePicker("surgeHouronestartingTime", formik.values.surgeHouronestartingTime)}
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                {renderTimePicker("surgeHouroneendingTime", formik.values.surgeHouroneendingTime)}
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Percentage :</Typography>
                {renderTextField("surgeHouronepercentage")}
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={6} style={{ marginTop: 12 }}>
            <Typography className={classes.sectionTitleHeader}>
              Surge based fare Surge Hour (Two)
            </Typography>
            <Box className={classes.sectionHeaderDivider} />

            <Grid container spacing={1.5}>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Starting Time :</Typography>
                {renderTimePicker("surgerHourtwostartingTime", formik.values.surgerHourtwostartingTime)}
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Ending Time :</Typography>
                {renderTimePicker("surgerHourtwoendingTime", formik.values.surgerHourtwoendingTime)}
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.fieldLabel}>Percentage :</Typography>
                {renderTextField("surgerHourtwopercentage")}
              </Grid>
            </Grid>
          </Grid>

          {/* Bottom Action Buttons */}
          <Grid item xs={12}>
            <Box className={classes.actionButtonsContainer}>
              <Button
                variant="outlined"
                className={classes.closeButtonAction}
                onClick={handleModalClose}
              >
                Close
              </Button>
              <Button
                variant="contained"
                className={classes.submitButtonAction}
                onClick={formik?.handleSubmit}
              >
                Update Zone Fare model
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ServiceUpdate;
